<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('old_org_admin')">
                    <Input v-model="admin_code" disabled/>
                </FormItem>
                <FormItem :label="$t('new_org_admin')" prop="admin_code">
                    <Input v-model="formData.admin_code" :placeholder="$t('input')"/>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    org_id: '',
                    admin_code: ''
                },
                rule: {
                    admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}]
                },
                admin_code: ''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.admin_code = this.$base.getRequest().admin_code;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                var url = "org-down-s0/upd-admin";
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            },
            clearUserInfo: function() {
                this.formData.user_cname = "";
                this.formData.u_id = "";
            },
            searchUserInfo: function () {
                this.clearUserInfo();

                this.$base.showLoading();
                this.$request.sendPost('role/get-add-user-info',this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if(data){
                            this.formData.user_cname = data.user_cname;
                            this.formData.u_id = data.u_id;
                        }
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs0_admin.vue